module.exports = __webpack_public_path__ + "img/logo.90731f83.svg";